import React, { Component } from "react";
import FontAwesome from "react-fontawesome";
import ReactPaginate from "react-paginate";
import { Box } from "reactjs-admin-lte";
import ReportStore from "../../stores/ReportStore";
import Select from "react-select";
import {
  FormControl,
  Button,
  ButtonToolbar,
  Row,
  Col,
  DropdownButton,
  MenuItem,
  Modal,
} from "react-bootstrap";
import { Checkbox } from "react-icheck";
import XLSX from "xlsx";
import FileSaver from "file-saver";
import IframeModal from "component/element/IframeModal";
import ReportWorkTable from "./ReportWorkTable";
import { max } from "lodash";
import ConfirmPopup from "component/element/ConfirmPopup";
import TermOfServiceModal from "../tos/TermOfServiceModal";
import "icheck/skins/all.css";
import WorkdocStore from "../../stores/WorkdocStore";
// import $ from 'jquery'
import { connect } from "react-redux";
const localStorageKey = "kkc.app.version";
const sessionStoragePage = "ckboss.body.report.activePage";
const localStorageAcceptKey = "ckboss_termofuse_accept";
const localStorageShowImgKey = "kkc.show_img";
var NotificationSystem = require("react-notification-system");

class ReportWork extends Component {
  constructor(...args) {
    super(...args);
    var dt = new Date();
    let { messages } = this.props;

    this.printMenuItem1 = [
      {
        key: "parkingcar_doc",
        title: messages["Parking Car Doc"],
        target: "pdf/v2/?startPage=PrintParkingCarDoc",
      },
      {
        key: "checkingcar_doc_sedan",
        title: messages["Checking Car Doc"] + " (" + messages["Sedan"] + ")",
        target: "pdf/?file=checkingcar_doc&car_body_img=carbody3.jpg",
      },
      {
        key: "checkingcar_doc_pickup",
        title: messages["Checking Car Doc"] + " (" + messages["Pickup"] + ")",
        target:
          "pdf/?file=checkingcar_doc&car_body_แสดงรายละเอียด=carbody_doublecab.jpg",
      },
      {
        key: "checkingcar_doc_truck",
        title: messages["Checking Car Doc"] + " (" + messages["Truck"] + ")",
        target: "pdf/?file=checkingcar_doc&car_body_img=carbody_truck.jpg",
      },
      {
        key: "checkingcar_doc_trailer",
        title: messages["Checking Car Doc"] + " (" + messages["Trailer"] + ")",
        target: "pdf/?file=checkingcar_doc&car_body_img=carbody_trailers2.jpg",
      },
      {
        key: "workqc_doc",
        title: messages["QC Doc"] + " " + messages["Format"] + " 1",
        target: "pdf/v2/?startPage=PrintWorkQCDoc",
      },
      {
        key: "workqc2_doc",
        title: messages["QC Doc"] + " " + messages["Format"] + " 2",
        target: "pdf/v2/?startPage=PrintKKCWorkQCDoc",
      },
      {
        key: "receivingcar_doc",
        title: messages["Receiving Car Doc"],
        target: "pdf/?file=receivingcar_doc",
      },
    ];

    this.printMenuItem2 = [
      {
        key: "parkingcar_doc",
        title: messages["Parking Car Doc"],
        target: "pdf/v2/?startPage=PrintParkingCarDoc",
      },
      {
        key: "checkingdamage_doc",
        title: messages["Checking Damage Doc"],
        target: "pdf/?file=checkingdamage_doc",
      },
      {
        key: "checkingcar_doc_carcarrier",
        title: messages["Checking Car Doc"] + " (Car Carrier)",
        target: "pdf/?file=checkingcar_doc&car_body_img=carbody_carcarrier.jpg",
      },
      {
        key: "checkingcar_doc_chassis",
        title: messages["Checking Car Doc"] + " (Container Chassis)",
        target: "pdf/?file=checkingcar_doc&car_body_img=carbody_trailers2.jpg",
      },
      {
        key: "checkingcar_doc_flatbed",
        title: messages["Checking Car Doc"] + " (Flat Bed)",
        target: "pdf/?file=checkingcar_doc&car_body_img=carbody_flatbed.jpg",
      },
      {
        key: "checkingcar_doc_chemicaltank",
        title: messages["Checking Car Doc"] + " (Tanker/Chemical)",
        target: "pdf/?file=checkingcar_doc&car_body_img=carbody_tanktruck.jpg",
      },
      {
        key: "checkingcar_doc_cargo",
        title: messages["Checking Car Doc"] + " (Multi Cargo)",
        target:
          "pdf/?file=checkingcar_doc&car_body_img=carbody_semitrailers.jpg",
      },
      {
        key: "checkingcar_doc_dumptruck",
        title: messages["Checking Car Doc"] + " (Dump)",
        target: "pdf/?file=checkingcar_doc&car_body_img=carbody_dumptruck.jpg",
      },
      {
        key: "workqc2_doc",
        title: messages["QC Doc"],
        target: "pdf/v2/?startPage=PrintKKCWorkQCDoc",
      },
      {
        key: "receivingcar_doc",
        title: messages["Receiving Car Doc"],
        target: "pdf/?file=receivingcar_doc",
      },
    ];

    this.state = {
      apiCall: "all",
      insurerList: [],
      insurerValue: "",
      insurerLoading: false,
      printMenuItem: this.printMenuItem1,
      checkingGroupIndex: -1,
      checking_by: "",
      isMobile: false,
      loading: false,
      showDetail: false,
      showUpgrade: false,
      filter: "car_registration_no",
      year: dt.getFullYear() * 1 + 543,
      month: "0",
      activePage: 0,//JSON.parse(sessionStorage.getItem(sessionStoragePage)),
      itemPerPage: 30,
      dataCount: 0,
      pageCount: 0,
      activeMenu: 0,
      query: "",
      data: [],
      dataExcel: [],
      checking_by_group: [],
      showBilling: false,
      showFinanceRemark: false,
      showJobDoneRemark: false,
      showImg: JSON.parse(localStorage.getItem(localStorageShowImgKey)) || {
        isShow: false,
      },
      showConfig: false,
      column_title: [],
      column_index: {},
      showUnprocessFinance: false,
      hasAdvanceDate: false,
      showFilter: false,
    };
    //this.onTabClick('all',0)
    this.checkVersion = true;
    // console.log('new render reportWork')
  }

  refreshReport() {
    let { apiCall, year, month, showDetail, itemPerPage, query, filter,activePage } =
      this.state;
    if (apiCall == "") {
      apiCall = "all";
    }
    this.loadReportWork(
      apiCall,
      year,
      month,
      showDetail,
      activePage * itemPerPage,
      itemPerPage,
      query,
      filter
    );
    this.setState({ apiCall: apiCall,  activeMenu: 0 });
  }

  componentDidMount() {
    if (this.props.onRef !== undefined) {
      this.props.onRef(this);
    }
    this._notificationSystem = this.refs.notificationSystem;
    // $('body').on('click', ()=> {
    //   if ($('.Select').hasClass('is-open'))
    //     $('.body-column-config').css( "overflow-y", "initial" );
    //   else
    //     $('.body-column-config').css( "overflow-y", "auto" );
    // });

    // document.querySelector("meta[property='og:image']").getAttribute("content");
    let { year, month, showDetail, itemPerPage, query, filter } = this.state;
    this.loadReportWork(
      "all",
      year,
      month,
      showDetail,
      0,
      itemPerPage,
      query,
      filter
    );
  }

  loadInsurer() {
    this.setState({ insurerLoading: true });
    WorkdocStore.loadInsurerList(
      "",
      0,
      0,
      (result) => {
        this.setState({ insurerList: result.data, insurerLoading: false });
      },
      () => {
        this.setState({ insurerLoading: false });
      }
    );
  }

  loadReportWork(
    apiCall,
    year,
    month,
    showDetail,
    start,
    length,
    query,
    cat,
    filter = { showUnprocessFinance: false, hasAdvanceDate: false }
  ) {
    let { checking_by, column_title } = this.state;
    const n = apiCall.search("\\?");
    if (n < 0) {
      if (checking_by != "") {
        apiCall += "?checking_by=" + checking_by;
      } else {
        this.setState({ checkingGroupIndex: -1, checking_by: "" });
      }
    }
    this.setState({ loading: true });
    let { printMenuItem } = this.state;
    ReportStore.loadReportWork(
      apiCall,
      year,
      month,
      showDetail,
      start,
      length,
      query,
      cat,
      filter,
      (result) => {
        //Laod OK
        if (this.checkVersion) {
          this.checkVersion = false;
          let cfg = JSON.parse(localStorage.getItem(localStorageKey)) || {
            version: "",
          };
          let tos = JSON.parse(localStorage.getItem(localStorageAcceptKey)) || {
            accept: false,
          };

          if (
            result.bf_app_version !== undefined &&
            cfg.version !== result.bf_app_version
          ) {
            this.bf_app_version = result.bf_app_version;
            if (tos.accept) {
              this.setState({ showUpgrade: true });
            } else {
              this.refs.tos.getWrappedInstance().loadData();
            }
          }
        }
        if (
          result.print_menu_item !== undefined &&
          result.print_menu_item === "2"
        ) {
          printMenuItem = this.printMenuItem2;
        }
        const showFinanceRemark =
          result.show_finance_remark !== undefined
            ? result.show_finance_remark
            : false;
        const showJobDoneRemark =
          result.show_jobdone_remark !== undefined
            ? result.show_jobdone_remark
            : false;
        column_title = result.column_title.map((item, index) => {
          item = Object.assign({ seq_no: index + 1 }, item);
          return item;
        });
        this.setState(
          {
            loading: false,
            printMenuItem: printMenuItem,
            showFinanceRemark: showFinanceRemark,
            showJobDoneRemark: showJobDoneRemark,
            checking_by_group: result.checking_by_group,
            data: result.data,
            dataCount: result.data_count,
            pageCount: result.data_count / length,
            column_index: result.column_index,
            column_title: column_title,
          },
          () => {
            this.refs.rWorkTB.getWrappedInstance().clearFilterSearchClick();
            if (query !== "" && result.data.length > 0)
              this.setState({ showFilter: true });
            else this.setState({ showFilter: false });
          }
        );
      },
      () => {
        this.setState({ loading: false }, () => {
          this.refs.rWorkTB.getWrappedInstance().clearFilterSearchClick();
          this.setState({ showFilter: false });
        });
      }
    );
  }

  onLoadExcelData(apiCall, completeFunc = undefined) {
    let {
      year,
      month,
      showDetail,
      query,
      filter,
      showUnprocessFinance,
      hasAdvanceDate,
    } = this.state;
    ReportStore.loadReportWork(
      apiCall,
      year,
      month,
      showDetail,
      0,
      "",
      query,
      filter,
      {
        showUnprocessFinance: showUnprocessFinance,
        hasAdvanceDate: hasAdvanceDate,
      },
      (result) => {
        this.setState({ dataExcel: result.data }, () => {
          completeFunc("OK");
        });
      }
    );
  }

  onAcceptClick() {
    localStorage.setItem(
      localStorageAcceptKey,
      JSON.stringify({ accept: true })
    );
    this.onUpgradeConfirm();
  }

  onPageChange(apiCall, item) {
    // let that = this
    let {
      itemPerPage,
      year,
      month,
      showDetail,
      showUnprocessFinance,
      hasAdvanceDate,
      query,
      filter,
    } = this.state;
    sessionStorage.setItem(
      sessionStoragePage,
      JSON.stringify({ activePage: item.selected })
    );
    this.setState({ activePage: item.selected });
    this.loadReportWork(
      apiCall,
      year,
      month,
      showDetail,
      item.selected * itemPerPage,
      itemPerPage,
      query,
      filter,
      {
        showUnprocessFinance: showUnprocessFinance,
        hasAdvanceDate: hasAdvanceDate,
      }
    );
  }

  onTabClick(apiCall, index) {
    this.setState({ activeMenu: index, activePage: 0, apiCall: apiCall });
    let {
      year,
      month,
      itemPerPage,
      showDetail,
      hasAdvanceDate,
      showUnprocessFinance,
      query,
      filter,
    } = this.state;
    this.loadReportWork(
      apiCall,
      year,
      month,
      showDetail,
      0,
      itemPerPage,
      query,
      filter,
      {
        showUnprocessFinance: showUnprocessFinance,
        hasAdvanceDate: hasAdvanceDate,
      }
    );
  }

  onYearChange(apiCall, e) {
    let {
      month,
      itemPerPage,
      showDetail,
      showUnprocessFinance,
      query,
      filter,
    } = this.state;
    let year = e.value;
    this.setState({ year: year, activePage: 0 });
    this.loadReportWork(
      apiCall,
      year,
      month,
      showDetail,
      0,
      itemPerPage,
      query,
      filter,
      { showUnprocessFinance: showUnprocessFinance }
    );
  }

  onMonthChange(apiCall, e) {
    let { year, itemPerPage, showDetail, showUnprocessFinance, query, filter } =
      this.state;
    let month = e.value;
    this.setState({ month: month, activePage: 0 });
    this.loadReportWork(
      apiCall,
      year,
      month,
      showDetail,
      0,
      itemPerPage,
      query,
      filter,
      { showUnprocessFinance: showUnprocessFinance }
    );
  }

  onFilterChange(e) {
    // console.log(e)
    let { insurerList, filter, query } = this.state;
    let curFilter = e ? e.value : "";
    if (curFilter == "insurer_id") {
      //Load Insurer
      if (insurerList.length == 0) {
        this.loadInsurer();
        this.onSearchClick("all", curFilter);
      }
    } else if (curFilter == "customer_cash") {
      this.onSearchClick("all", curFilter);
    }
    if (filter !== curFilter) {
      query = "";
    }
    this.setState({ filter: curFilter, query: query });
  }

  onInsurerChange(e) {
    let insurerValue = e ? e.value : "";

    this.setState({ insurerValue: insurerValue, query: insurerValue });

    this.onSearchClick(insurerValue, null);
  }

  onSearchClick(searchParam = "", curFilter = "") {
    let { query, filter, itemPerPage, showDetail, apiCall, year, month } =
      this.state;
    if (searchParam !== null) {
      query = searchParam;
    }
    if (curFilter !== null) {
      filter = curFilter;
    }
    this.setState({ loading: true });
    // ReportStore.loadReportWorkQuery(apiCall,query, filter, showDetail,  (result)=> {
    //   //Laod OK
    //   this.setState({ loading:false, data: result.data,dataCount:result.data_count, pageCount: result.data_count / itemPerPage })
    // },()=>{
    //   this.setState({loading:false})
    // })
    this.loadReportWork(
      apiCall,
      year,
      month,
      showDetail,
      0,
      itemPerPage,
      query,
      filter
    );
  }

  onFilterClearSearch(completeFunc = undefined) {
    this.setState({ filter: "", query: "" }, () => {
      this.onSearchClick();
      setTimeout(() => {
        if (completeFunc !== undefined) completeFunc();
      }, 1000);
    });
  }

  onFilterSearch(rItem, completeFunc = undefined) {
    let { query, filter } = this.state;
    this.setState({ filter: "car_info", query: rItem }, () => {
      this.onSearchClick(rItem, "car_info");
      if (completeFunc !== undefined) completeFunc();
    });
  }

  onQueryChange(e) {
    // let { filter, itemPerPage } = this.state
    let query = e.target.value;
    this.setState({ query: query });

    // if(query.length==0 || query.length==3 || query.length==5){
    //   let that = this
    //   ReportStore.loadReportWorkQuery(query,filter,function(result){
    //   //Laod OK
    //     that.setState({data:result.data,pageCount:result.data_count/itemPerPage})
    //   })
    // }
  }

  onHasAdvanceDateChange(apiCall, e) {
    let {
      hasAdvanceDate,
      year,
      month,
      showDetail,
      itemPerPage,
      query,
      filter,
    } = this.state;
    hasAdvanceDate = !hasAdvanceDate;
    this.setState({ hasAdvanceDate: hasAdvanceDate });
    this.loadReportWork(
      apiCall,
      year,
      month,
      showDetail,
      0,
      itemPerPage,
      query,
      filter,
      { hasAdvanceDate: hasAdvanceDate }
    );
  }

  onShowDetailChange(apiCall, e, showDetail) {
    // console.log('changeDetail', e, showDetail)
    let { year, month, itemPerPage, activePage, query, filter } = this.state;
    this.setState({ showDetail: showDetail });
    if (showDetail) {
      // if (query !== '') {

      //   this.setState({ loading: true })
      //   ReportStore.loadReportWorkQuery(apiCall,query, filter, showDetail,  (result)=> {
      //     //Laod OK
      //     this.setState({ loading: false, data: result.data,dataCount:result.data_count, pageCount: result.data_count / itemPerPage })
      //   })
      // } else {
      //   this.loadReportWork(apiCall, year, month, showDetail, activePage * itemPerPage, itemPerPage)
      // }
      this.loadReportWork(
        apiCall,
        year,
        month,
        showDetail,
        activePage * itemPerPage,
        itemPerPage,
        query,
        filter
      );
    }
  }

  onShowImgChange() {
    let { showImg } = this.state;
    if (showImg.isShow) {
      showImg.isShow = false;
    } else {
      showImg.isShow = true;
    }

    let config = { isShow: showImg.isShow };
    localStorage.setItem(localStorageShowImgKey, JSON.stringify(config));
    this.setState({ showImg: showImg });
  }

  onSearchKeyPress(target) {
    if (target.charCode == 13) {
      let { query, filter, itemPerPage, showDetail, apiCall, year, month } =
        this.state;
      // let that = this
      // ReportStore.loadReportWorkQuery(apiCall,query, filter, showDetail, function (result) {
      //   //Laod OK
      //   that.setState({ data: result.data,dataCount:result.data_count, pageCount: result.data_count / itemPerPage })
      // })
      this.loadReportWork(
        apiCall,
        year,
        month,
        showDetail,
        0,
        itemPerPage,
        query,
        filter
      );
    }
  }

  onBillingReportClick() {
    //alert('กำลังอยู่ในการพัฒนา');
    this.refs.reportBilling.loadInit();
    this.setState({ showBilling: true });
  }

  onNewWorkClick() {
    if (process.env.NODE_ENV == "development") {
      alert("click new work");
    } else {
      window.show_work_doc("", undefined, "normal");
    }
  }

  onRowWorkClick(workNo) {
    if (process.env.NODE_ENV == "development") {
      // console.log('click work ' + workNo)
      if (typeof this.props.onRowWorkClick === "undefined") return;
      this.props.onRowWorkClick(workNo);
    } else {
      window.show_work_doc(workNo);
    }
  }

  onUpgradeConfirm() {
    localStorage.setItem(
      localStorageKey,
      JSON.stringify({ version: this.bf_app_version })
    );
    window.location.reload(true);
    this.setState({ showUpgrade: false });
  }

  onCheckingByGroupClick(apiCall, item, index) {
    this.setState({
      checkingGroupIndex: index,
      checking_by: item.checking_by,
      activePage: 0,
    });
    apiCall += "?checking_by=" + item.checking_by;
    let { year, month, showDetail, itemPerPage, query, filter } = this.state;
    this.loadReportWork(
      apiCall,
      year,
      month,
      showDetail,
      0,
      itemPerPage,
      query,
      filter
    );
  }

  onExportExcel(apiCall, e) {
    this.onLoadExcelData(apiCall, (result) => {
      let { column_title, data, column_index } = this.state;
      let { messages } = this.props;
      let checkColumn = [];

      data.forEach((item) => {
        column_title.forEach((citem, cindex) => {
          if (citem.visible) {
            let itemColumn = item[column_index[citem.key]];
            let itemLength =
              itemColumn !== null && itemColumn !== undefined
                ? itemColumn.length
                : 0;

            if (citem.key === "FINANCE_STATUS") {
              return;
            }

            if (citem.key === "STATUS") {
              if (itemColumn === "1") {
                itemLength = messages["Under Repair"].length;
              } else if (itemColumn === "2") {
                itemLength = messages["Wait For Delivery"].length;
              } else if (itemColumn === "3") {
                itemLength = messages["Work Done"].length;
              } else if (itemColumn === "4") {
                itemLength = messages["Have Problem"].length;
              } else if (itemColumn === "5") {
                itemLength = messages["Payment"].length;
              } else if (itemColumn === "6") {
                itemLength = messages["Not Yet Quotation"].length;
              } else if (itemColumn === "7") {
                itemLength = messages["Job Has Not Been Issued"].length;
              } else if (itemColumn === "8") {
                itemLength = messages["Car Not Parked"].length;
              }
            }

            if (citem.key === "REMARK") {
              itemLength = 20;
            }

            if (checkColumn[cindex]) {
              checkColumn[cindex].push(itemLength);
            } else {
              checkColumn[cindex] = [itemLength];
            }
          }
        });
      });

      var wscols = [];
      checkColumn.forEach((item, index) => {
        let widthMax = max(item);
        if (item) {
          wscols.push({ width: widthMax === 0 ? 18 : widthMax + 6 });
        }
      });
      console.log("wscols", wscols);

      if (result === "OK") {
        const worksheet = XLSX.utils.table_to_book(
          document.getElementById("ReportWork-Export-Excel")
        );

        worksheet["Sheets"]["Sheet1"]["!cols"] = wscols;

        let wbout = XLSX.write(worksheet, {
          bookType: "xlsx",
          bookSST: true,
          type: "binary",
        });

        function s2ab(s) {
          var buf = new ArrayBuffer(s.length);
          var view = new Uint8Array(buf);
          for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
          return buf;
        }
        const fileName = "รายงานงานซ่อม.xlsx";
        FileSaver.saveAs(
          new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
          fileName
        );
      }
    });
  }

  onTablePrint(apiCall, activeMenu, rowClass) {
    let { year, month, showDetail, query, filter } = this.state;
    let { showStatus, autoRefresh, chassisPrimary } = this.props;
    let url = "";
    let cat = filter;
    if (process.env.NODE_ENV == "development") {
      url =
        "./?startPage=PrintReportWork&apiCall=" +
        apiCall +
        "&year=" +
        year +
        "&month=" +
        month +
        "&showDetail=" +
        showDetail +
        "&query=" +
        query +
        "&cat=" +
        cat +
        "&showStatus=" +
        showStatus +
        "&autoRefresh=" +
        autoRefresh +
        "&chassisPrimary=" +
        chassisPrimary +
        "&rowClass=" +
        rowClass;
    } else {
      url =
        "./pdf/v2/?startPage=PrintReportWork&apiCall=" +
        apiCall +
        "&year=" +
        year +
        "&month=" +
        month +
        "&showDetail=" +
        showDetail +
        "&query=" +
        query +
        "&filter=" +
        filter +
        "&showStatus=" +
        showStatus +
        "&autoRefresh=" +
        autoRefresh +
        "&chassisPrimary=" +
        chassisPrimary +
        "&rowClass=" +
        rowClass;
    }
    this.refs.iframe.loadUrl(url);
  }

  renderFormSearch() {
    let { filter, insurerValue, insurerLoading, query, showDetail } =
      this.state;
    let { messages } = this.props;
    let showInput = filter !== "insurer_id";
    return (
      <form className="navbar-left " style={{ marginLeft: "15px" }}>
        <div className="form-group ">
          <div style={{ width: "180px", display: "inline-block" }}>
            <Select
              className="report-work-height-menu-outer"
              options={this.getFilterOptions()}
              value={filter}
              placeholder={messages["Select Category"]}
              onChange={this.onFilterChange.bind(this)}
              clearable={false}
            />
          </div>
          <div
            style={{
              width: "280px",
              display: !showInput ? "inline-block" : "none",
            }}
          >
            <Select
              options={this.getInsurerOptions()}
              value={insurerValue}
              placeholder={messages["Select Insurer"]}
              onChange={this.onInsurerChange.bind(this)}
              clearable={true}
              loading={insurerLoading}
            />
          </div>
          <div
            style={{
              width: "280px",
              display: showInput ? "inline-block" : "none",
            }}
          >
            <div className="input-group ">
              <FormControl
                value={query}
                placeholder={messages["Search Worksheet"]}
                onKeyPress={this.onSearchKeyPress.bind(this)}
                onChange={this.onQueryChange.bind(this)}
              />
              <span className="input-group-btn">
                <Button
                  className="btn-flat"
                  onClick={this.onSearchClick.bind(this, null, null)}
                >
                  <FontAwesome name="search" />
                </Button>
              </span>
            </div>
          </div>
        </div>
      </form>
    );
  }

  getYearOptions() {
    let options = [];
    var dt = new Date();
    for (let i = dt.getFullYear() * 1 + 543; i >= 2558; i--) {
      options.push({ label: i, value: i });
    }
    return options;
  }

  getMonthOptions() {
    let { messages } = this.props;
    return [
      { label: messages["All Year"], value: "0" },
      { label: messages["January"], value: "01" },
      { label: messages["February"], value: "02" },
      { label: messages["March"], value: "03" },
      { label: messages["April"], value: "04" },
      { label: messages["May"], value: "05" },
      { label: messages["June"], value: "06" },
      { label: messages["July"], value: "07" },
      { label: messages["August"], value: "08" },
      { label: messages["September"], value: "09" },
      { label: messages["October"], value: "10" },
      { label: messages["November"], value: "11" },
      { label: messages["December"], value: "12" },
    ];
  }

  getFilterOptions() {
    let { messages, showVipMember } = this.props;

    return [
      { value: "car_registration_no", label: messages["Car Registration"] },
      { value: "owner_name", label: messages["Customer"] },
      { value: "owner_tel", label: messages["Phone"] },
      { value: "vip_member", label: messages["VIP Member"] },
      { value: "work_no", label: messages["Worksheet No"] },
      { value: "chassis_no", label: messages["Chassis Number"] },
      { value: "car_info", label: messages["Brand/Model"] },
      { value: "customer_cash", label: messages["Cash Customers"] },
      { value: "insurer_id", label: messages["Insurer"] },
      { value: "item_part", label: messages["Search Part"] },
      { value: "item_wage", label: messages["Search Wage"] },
      { value: "car_paint_type", label: 'สีที่พ่น' },
    ];
  }

  getInsurerOptions() {
    let { insurerList } = this.state;

    return insurerList.map((item, index) => {
      return { value: item.bf_insurer_id, label: item.name };
    });
  }

  onShowUnprocessFinanceChange(apiCall) {
    let {
      showUnprocessFinance,
      year,
      month,
      showDetail,
      itemPerPage,
      query,
      filter,
    } = this.state;
    showUnprocessFinance = showUnprocessFinance ? false : true;
    this.setState({ showUnprocessFinance: showUnprocessFinance });
    this.loadReportWork(
      apiCall,
      year,
      month,
      showDetail,
      0,
      itemPerPage,
      query,
      filter,
      { showUnprocessFinance: showUnprocessFinance }
    );
  }

  renderCheckbox(apiCall) {
    let { showDetail, showImg, showUnprocessFinance } = this.state;
    let { messages } = this.props;
    return (
      <div
        style={{
          width: "auto",
          display: "inline-block",
          lineHeight: "32px",
          marginLeft: "15px",
        }}
      >
        <Checkbox
          checkboxClass="icheckbox_square-blue"
          increaseArea="20%"
          label={" " + messages["Show Detail"]}
          value={showDetail}
          onChange={this.onShowDetailChange.bind(this, apiCall)}
        />
        &nbsp;
        <Checkbox
          checkboxClass="icheckbox_square-blue"
          increaseArea="20%"
          label={" " + messages["Show Image"]}
          checked={showImg.isShow}
          onChange={this.onShowImgChange.bind(this)}
        />
        &nbsp;
        {apiCall === "wait_for_payment" ? (
          <Checkbox
            checkboxClass="icheckbox_square-blue"
            increaseArea="20%"
            label={" " + messages["Wait For Payment"]}
            checked={showUnprocessFinance}
            onChange={this.onShowUnprocessFinanceChange.bind(this, apiCall)}
          />
        ) : (
          ""
        )}
      </div>
    );
  }

  getNumberFormat(value, decimal = 2) {
    let _val =
      value === "" || value === null || value === undefined || isNaN(value)
        ? 0
        : value;
    _val = parseFloat(_val);
    return _val.toFixed(decimal).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  }

  renderCheckingByGroup(apiCall, index) {
    let { checking_by_group, checkingGroupIndex } = this.state;

    if (checking_by_group == undefined || checking_by_group.length == 0) {
      return <div />;
    } else {
      let len = checking_by_group.length > 0 ? checking_by_group.length : 1;
      let percent = Math.floor(100 / len);

      let title = "จำนวนจ็อบแบ่งตามผู้รับผิดชอบ";
      if (apiCall === "wait_for_payment") title = "จำนวนรายการแบ่งตามตั้งเบิก";
      return (
        <Row>
          <Col md={12}>{title}</Col>
          <Col md={12}>
            <div className="table-responsive">
              <table
                className="table table-hover table-bordered-solid"
                style={{ minWidth: "1280px" }}
              >
                <thead>
                  <tr>
                    <th>
                      <div style={{ width: 70 }}></div>
                    </th>
                    {checking_by_group.map((item, index) => {
                      return (
                        <th
                          key={index}
                          className="text-center"
                          style={{ width: percent + "%" }}
                        >
                          <span>{item.checking_by}</span>
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>งาน</td>
                    {checking_by_group.map((item, index) => {
                      return (
                        <td
                          key={index}
                          className={
                            "text-center " +
                            (checkingGroupIndex == index ? "bg-gray" : "")
                          }
                        >
                          <button
                            onClick={this.onCheckingByGroupClick.bind(
                              this,
                              apiCall,
                              item,
                              index
                            )}
                          >
                            <FontAwesome name="search" />
                          </button>{" "}
                          <span>{item.no_of_work}</span>
                        </td>
                      );
                    })}
                  </tr>
                  <tr>
                    <td>ราคาเสนอ</td>
                    {checking_by_group.map((item, index) => {
                      return (
                        <td
                          key={index}
                          className={
                            "text-center " +
                            (checkingGroupIndex == index ? "bg-gray" : "")
                          }
                        >
                          {" "}
                          <span
                            className={index == 0 ? "label label-warning" : ""}
                          >
                            {this.getNumberFormat(item.sum_amount, 2)}
                          </span>
                        </td>
                      );
                    })}
                  </tr>
                  <tr>
                    <td>อนุมัติ </td>
                    {checking_by_group.map((item, index) => {
                      return (
                        <td
                          key={index}
                          className={
                            "text-center " +
                            (checkingGroupIndex == index ? "bg-gray" : "")
                          }
                        >
                          {" "}
                          <span
                            className={index == 0 ? "label label-success" : ""}
                          >
                            {this.getNumberFormat(item.sum_approved, 2)}
                          </span>
                        </td>
                      );
                    })}
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
          </Col>
        </Row>
      );
    }
  }

  renderFilterAdvanceDateOption(apiCall, index) {
    let { hasAdvanceDate } = this.state;
    if (["nopark"].includes(apiCall)) {
      return (
        <Row>
          <div
            style={{
              width: "auto",
              display: "inline-block",
              lineHeight: "32px",
              marginLeft: "15px",
            }}
          >
            <Checkbox
              checkboxClass="icheckbox_square-blue"
              increaseArea="20%"
              label={" เฉพาะแจ้งเข้าซ่อมล่วงหน้า"}
              value={hasAdvanceDate}
              onChange={this.onHasAdvanceDateChange.bind(this, apiCall)}
            />
            &nbsp;
          </div>
        </Row>
      );
    }
  }

  renderSearch(apiCall, index, rowClass) {
    if (
      [
        "all",
        "new",
        "no_quotation",
        "no_job",
        "start",
        "wait_for_customer",
        "credit",
        "junk",
        "wait_for_payment",
        "job_done",
        "payment_received",
        "nopark",
        "receiving",
        "delivering",
      ].includes(apiCall)
    ) {
      let { month, year, isMobile } = this.state;
      return (
        <Row>
          <div className=" navbar-left" style={{ paddingLeft: "15px" }}>
            <div className="form-group search-record">
              <div style={{ width: "80px", display: "inline-block" }}>
                <Select
                  value={year}
                  options={this.getYearOptions()}
                  onChange={this.onYearChange.bind(this, apiCall)}
                  clearable={false}
                />
              </div>
              <div style={{ width: "180px", display: "inline-block" }}>
                <Select
                  clearable={false}
                  value={month}
                  options={this.getMonthOptions()}
                  onChange={this.onMonthChange.bind(this, apiCall)}
                />
              </div>
            </div>
          </div>
          {this.renderFormSearch(apiCall)}
          {!isMobile ? this.renderCheckbox(apiCall) : ""}
          <span
            style={{ cursor: "pointer" }}
            onClick={this.onExportExcel.bind(this, apiCall)}
          >
            <FontAwesome className="text-green" name="file-excel-o" /> ออกไฟล์
            Excel
          </span>
          <span
            style={{ cursor: "pointer" }}
            onClick={this.onTablePrint.bind(
              this,
              apiCall,
              this.state.activeMenu,
              rowClass
            )}
          >
            <FontAwesome style={{ color: "#d81b60" }} name="print" />{" "}
            {this.props.messages["Print Document"]}
          </span>
        </Row>
      );
    } else {
      return <div />;
    }
  }

  renderPaging(apiCall) {
    let { activePage } = this.state;
    return (
      <div className="commentBox">
        <ReactPaginate
          forcePage={activePage}
          previousLabel={this.props.messages["Previous"]}
          nextLabel={this.props.messages["Next"]}
          breakLabel={<a href="">...</a>}
          breakClassName={"break-me"}
          pageCount={this.state.pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={2}
          onPageChange={this.onPageChange.bind(this, apiCall)}
          containerClassName={"pagination pull-right"}
          subContainerClassName={"pages pagination"}
          activeClassName={"active"}
        />
      </div>
    );
  }

  onMenuItemSelect(eventKey) {
    let url = "";

    let item = this.state.printMenuItem.find((element) => {
      return element.key === eventKey;
    });

    if (item !== null) {
      if (process.env.NODE_ENV == "development") {
        if (item.target.startsWith("pdf/v2")) {
          url = "./" + item.target.replace("pdf/v2", "");
        } else {
          url = "https://demo2.bigfix.co/korat/" + item.target;
        }
      } else {
        url = "./" + item.target;
      }
      this.refs.iframe.loadUrl(url);
    } else {
      //Nothing
    }
  }

  renderPrintDocMenu() {
    let { messages } = this.props;
    let title = (
      <span>
        <FontAwesome name="print" /> {messages["Print Blank Document"]}
      </span>
    );

    return (
      <ButtonToolbar
        style={{ display: this.props.showPrintEmptyDoc ? "" : "none" }}
      >
        <DropdownButton
          id="print-empty-doc"
          bsStyle={"primary"}
          title={title}
          pullRight
          onSelect={this.onMenuItemSelect.bind(this)}
        >
          {this.state.printMenuItem.map((item, index) => (
            <MenuItem key={index} eventKey={item.key}>
              <FontAwesome name="file-text-o" className="text-green" />
              {item.title}
            </MenuItem>
          ))}
        </DropdownButton>
      </ButtonToolbar>
    );
  }

  onSetIsMobile(isMobile) {
    this.setState({ isMobile: isMobile });
  }

  onUpdateData(items) {
    let {
      data,
      year,
      month,
      showDetail,
      itemPerPage,
      activeMenu,
      query,
      filter,
    } = this.state;
    this.setState({ data: data, loading: true });
    let postData = {
      wo: data[items.index][0],
      delivering: { finance_remark: items.text, finance_status: items.status },
    };
    let api = "";
    if (activeMenu === 7) {
      postData = {
        wo: data[items.index][0],
        delivering: {
          finance_remark: items.text,
          finance_status: items.status,
        },
      };
      api = "wait_for_payment";
    } else if (activeMenu === 8) {
      postData = {
        wo: data[items.index][0],
        delivering: { jobdone_remark: items.text },
      };
      api = "job_done";
    }

    WorkdocStore.saveInfoDelivering(postData, (result) => {
      this.setState({ loading: false });
      this.loadReportWork(
        api,
        year,
        month,
        showDetail,
        0,
        itemPerPage,
        query,
        filter
      );
    });
  }

  onColumnIndexChange(index, e) {
    let { column_title } = this.state;
    column_title[index].key = e.value;
    column_title[index].title = e.label;
    this.setState({ column_title: column_title });
  }

  onClassNameChange(index, e) {
    let { column_title } = this.state;
    column_title[index].class_name = e == null ? "" : e.value;
    this.setState({ column_title: column_title });
  }

  onColumnIndexCheck(index, e) {
    let { column_title } = this.state;
    if (typeof column_title[index].visible === "undefined") {
      column_title[index] = Object.assign(
        { visible: false },
        column_title[index]
      );
    } else if (column_title[index].visible) {
      column_title[index].visible = false;
    } else {
      column_title[index].visible = true;
    }
    this.setState({ column_title: column_title });
  }

  onConfigSortItem(index, action) {
    let { column_title } = this.state;
    let seq = column_title[index].seq_no;
    if (action === "up") {
      if (column_title.length > 1) {
        if (index > 0) {
          column_title[index - 1].seq_no = seq;
          let _seq = seq - 1;
          column_title[index].seq_no = _seq;
          column_title.sort(function (a, b) {
            if (a.seq_no < b.seq_no) return -1;
            if (a.seq_no > b.seq_no) return 1;
            return 0;
          });
          this.saveColumnConfig();
        }
      }
    } else if (action === "down") {
      if (column_title.length > 1) {
        if (index < column_title.length - 1) {
          column_title[index + 1].seq_no = seq;
          let _seq = seq * 1 + 1;
          column_title[index].seq_no = _seq;
          column_title.sort(function (a, b) {
            if (a.seq_no < b.seq_no) return -1;
            if (a.seq_no > b.seq_no) return 1;
            return 0;
          });
          this.saveColumnConfig();
        }
      }
    }
    this.setState({ column_title: column_title });
  }

  saveColumnConfig() {
    let { column_title } = this.state;
    let { messages } = this.props;
    let postData = { data: column_title };
    this.setState({ loading: true });
    ReportStore.saveColumnConfig(
      postData,
      (result) => {
        if (result.status === "OK") {
          this.setState({ loading: false });
          this._notificationSystem.addNotification({
            title: messages["Notice"],
            message: messages["Save Successfully"],
            level: "info",
            position: "tc",
          });
        }
      },
      () => {
        this.setState({ loading: false });
        this._notificationSystem.addNotification({
          title: messages["Notice"],
          message: messages["Save Fail"],
          level: "error",
          position: "tc",
        });
      }
    );
  }

  renderAmount() {
    let { checking_by_group, checkingGroupIndex } = this.state;

    if (checking_by_group == undefined || checking_by_group.length == 0) {
      return null;
    } else {
      return (
        <div style={{ display: "inline-flex" }}>
          {" "}
          เสนอทั้งหมด
          <span className="label label-warning">
            {" "}
            {this.getNumberFormat(checking_by_group[0].sum_amount, 2)} บาท
          </span>{" "}
          อนุมัติทั้งหมด
          <span className="label label-success">
            {" "}
            {this.getNumberFormat(checking_by_group[0].sum_approved, 2)} บาท
          </span>
        </div>
      );
    }
  }

  renderWorkTable(item, index) {
    let {
      data,
      column_index,
      column_title,
      showDetail,
      dataCount,
      showImg,
      showFinanceRemark,
      showJobDoneRemark,
    } = this.state;
    let { messages } = this.props;
    return (
      <Box loading={this.state.loading}>
        <Box.Header border={true} className={item.className}>
          <Box.Title>
            {item.title}{" "}
            <span className="label label-default">
              {dataCount} {messages["Job"]}
            </span>{" "}
            {this.renderAmount()}{" "}
            <FontAwesome
              style={{ cursor: "pointer" }}
              name="gear"
              onClick={() => {
                this.setState({ showConfig: true });
              }}
            />
          </Box.Title>
          <Box.Tools>{this.renderPrintDocMenu()}</Box.Tools>
        </Box.Header>
        <Box.Body>
          {this.renderFilterAdvanceDateOption(item.apiCall, index)}
          {this.renderSearch(item.apiCall, index, item.rowClass)}
          {this.renderCheckingByGroup(item.apiCall, index)}
          <ReportWorkTable
            ref="rWorkTB"
            rowClass={item.rowClass}
            data={data}
            columnIndex={column_index}
            columnTitle={column_title}
            showDetail={showDetail}
            showImg={showImg.isShow}
            showStatus={
              item.apiCall == "all" ||
              item.apiCall == "credit" ||
              item.apiCall == "junk"
            }
            showAdvanceDate={item.apiCall == "nopark"}
            showWaitForPaymentRemark={
              item.apiCall == "wait_for_payment" && showFinanceRemark
            }
            showJobDoneRemark={item.apiCall == "job_done" && showJobDoneRemark}
            onRowWorkClick={this.onRowWorkClick.bind(this)}
            onSetIsMobile={this.onSetIsMobile.bind(this)}
            onUpdateData={this.onUpdateData.bind(this)}
            onFilterSearch={this.onFilterSearch.bind(this)}
            onFilterClearSearch={this.onFilterClearSearch.bind(this)}
            showFilter={this.state.showFilter}
            tableId="ReportWork-Export-Excel"
            dataExcel={this.state.dataExcel}
          />
          {this.renderPaging(item.apiCall)}
        </Box.Body>
      </Box>
    );
  }

  renderConfigRowData() {
    let { column_title } = this.state;
    let { messages } = this.props;
    if (column_title.length === 0) {
      return (
        <tr>
          <td colSpan={4}>{messages["No Data"]}</td>
        </tr>
      );
    } else {
      let options = [
        { label: messages["Date"], value: "WORK_DATE" },
        { label: messages["Work No"], value: "WORK_NO" },
        { label: messages["Car Registration"], value: "CAR_REGISTRATION_NO" },
        { label: messages["Brand"], value: "BRAND" },
        { label: messages["Model"], value: "MODEL" },
        { label: messages["Mileage"], value: "MILEAGE" },
        { label: messages["Claim No"], value: "CLAIM_NO" },
        { label: messages["Customer"], value: "CUSTOMER" },
        { label: messages["Amount"], value: "AMOUNT" },
        { label: messages["Approve"], value: "APPROVED_AMOUNT" },
        { label: messages["Remark"], value: "REMARK" },
        { label: messages["Finance Remark"], value: "FINANCE_REMARK" },
        { label: messages["Job Done Remark"], value: "JOBDONE_REMARK" },
        { label: messages["Status"], value: "STATUS" },
        { label: messages["Responsible Person"], value: "RESPONSE_PERSON" },
      ];
      options = column_title.map((item, index) => {
        return { label: item.title, value: item.key };
      });
      let options_text = [
        { label: messages["Center"], value: "text-center" },
        { label: messages["Right"], value: "text-right" },
        { label: messages["Left"], value: "text-left" },
      ];
      return column_title.map((item, index) => {
        return (
          <tr key={index}>
            <td className="text-center">
              <Checkbox
                checkboxClass="icheckbox_square-blue"
                increaseArea="20%"
                label=""
                checked={
                  item.visible === undefined || item.visible ? true : false
                }
                onChange={this.onColumnIndexCheck.bind(this, index)}
              />
            </td>
            <td className="text-left">
              <Select
                options={options}
                value={item.key}
                placeholder={messages["Select Field Name"]}
                onChange={this.onColumnIndexChange.bind(this, index)}
                clearable={false}
              />
            </td>
            <td className="text-left">
              <Select
                options={options_text}
                value={item.class_name}
                placeholder={messages["Select Position Data"]}
                onChange={this.onClassNameChange.bind(this, index)}
                clearable={true}
              />
            </td>
            <td className="text-center">
              <div>
                <Button
                  bsSize="sm"
                  bsStyle="default"
                  onClick={this.onConfigSortItem.bind(this, index, "up")}
                >
                  <FontAwesome name="sort-up" />
                </Button>
                &nbsp;
                <Button
                  bsSize="sm"
                  bsStyle="default"
                  onClick={this.onConfigSortItem.bind(this, index, "down")}
                >
                  <FontAwesome name="sort-down" />
                </Button>
              </div>
            </td>
          </tr>
        );
      });
    }
  }

  renderConfigTable() {
    let { messages } = this.props;
    return (
      <div>
        <table className="table table-hover table-bordered-solid">
          <thead>
            <tr>
              <th className="text-center" style={{ width: "50px" }}></th>
              <th className="text-center" style={{ width: "150px" }}>
                {messages["Field Name"]}
              </th>
              <th className="text-center" style={{ width: "150px" }}>
                {messages["Position Data"]}
              </th>
              <th className="text-center" style={{ width: "100px" }}>
                {messages["Edit"]}
              </th>
            </tr>
          </thead>
          <tbody>{this.renderConfigRowData()}</tbody>
        </table>
      </div>
    );
  }

  renderModalConfig() {
    let { showConfig, loading } = this.state;
    let { messages } = this.props;
    return (
      <div>
        <Modal
          bsSize="large"
          show={showConfig}
          onHide={() => {
            this.setState({ showConfig: false });
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>{messages["Add/Delete"]}</Modal.Title>
          </Modal.Header>
          <Modal.Body
            className="body-column-config"
            style={{ overflowY: "auto", maxHeight: "calc(100vh - 190px)" }}
          >
            <Box loading={loading}>
              <Box.Body>{this.renderConfigTable()}</Box.Body>
            </Box>
          </Modal.Body>
          <Modal.Footer>
            <Button
              bsStyle="primary"
              onClick={this.saveColumnConfig.bind(this)}
            >
              <FontAwesome name="save" />
              &nbsp;{messages["Save"]}
            </Button>
            <Button
              bsStyle="default"
              onClick={() => {
                this.setState({ showConfig: false });
              }}
            >
              <FontAwesome name="close" />
              &nbsp;{messages["Close"]}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }

  render() {
    let { activeMenu, showUpgrade } = this.state;
    let { messages } = this.props;
    let menu = [
      {
        name: messages["All"],
        className: "",
        icon: "files-o",
        title: messages["All Work Table"],
        apiCall: "all",
        rowClass: "",
      },
      {
        name: messages["Start"],
        className: "",
        icon: "clock-o",
        title: messages["Work Table"],
        apiCall: "new",
        rowClass: "tab-bg-lightgray",
      },
      {
        name: messages["Not Yet Quotation"],
        className: "tab-bg-lightgray",
        icon: "file-text-o",
        title: messages["Work Table"],
        apiCall: "no_quotation",
        rowClass: "tab-bg-lightyellow",
      },
      {
        name: messages["Job Has Not Been Issued"],
        className: "tab-bg-lightyellow",
        icon: "wrench",
        title: messages["Work Table"],
        apiCall: "no_job",
        rowClass: "",
      },
      {
        name: messages["Car Not Parked"],
        className: "tab-bg-pink",
        icon: "car",
        title: messages["Work Table"],
        apiCall: "nopark",
        rowClass: "pink-row",
      },
      {
        name: messages["Under Repair"],
        className: "tab-bg-yellow",
        icon: "wrench",
        title: messages["Work Table"],
        apiCall: "start",
        rowClass: "orange-row",
      },
      {
        name: messages["Wait For Delivery"],
        className: "tab-bg-blue",
        icon: "hourglass-start",
        title: messages["Work Table"],
        apiCall: "wait_for_customer",
        rowClass: "blue-row",
      },
      {
        name: messages["Export"],
        className: "tab-bg-purple",
        icon: "bitcoin",
        title: messages["Work Table"],
        apiCall: "wait_for_payment",
        rowClass: "purple-row",
      },
      {
        name: messages["Work Done"],
        className: "tab-bg-green",
        icon: "thumbs-o-up",
        title: messages["Work Table"],
        apiCall: "job_done",
        rowClass: "green-row",
      },
      {
        name: messages["Received Money"],
        className: "tab-bg-skyblue",
        icon: "money",
        title: messages["Work Table"],
        apiCall: "payment_received",
        rowClass: "tab-bg-skyblue",
      },
      {
        name: messages["Credit"],
        className: "",
        icon: "money",
        title: messages["Work Table"],
        apiCall: "credit",
        rowClass: "",
      },
      {
        name: messages["Car in"],
        className: "",
        icon: "long-arrow-down",
        title: messages["Work Table"],
        apiCall: "receiving",
        rowClass: "",
      },
      {
        name: messages["Car out"],
        className: "",
        icon: "long-arrow-up",
        title: messages["Work Table"],
        apiCall: "delivering",
        rowClass: "",
      },
      {
        name: messages["Cancel Work"],
        className: "tab-bg-red",
        icon: "ban",
        title: messages["Work Table"],
        apiCall: "junk",
        rowClass: "red-row",
      },
    ];

    // if(this.props.showParkingTab){
    //   menu.splice(4, 0, { name: 'รถไม่จอดซ่อม', className: 'tab-bg-pink', icon: 'car', title: 'ตารางงาน', apiCall: 'nopark', rowClass: 'pink-row' });
    // }

    return (
      <div className="col-md-12">
        <div className="nav-tabs-custom">
          <ul className="nav nav-tabs">
            {menu.map((item, index) => (
              <li key={index} className={index == activeMenu ? "active" : ""}>
                <a
                  className={item.className}
                  onClick={this.onTabClick.bind(this, item.apiCall, index)}
                >
                  <FontAwesome
                    className={
                      item.apiCall === "receiving"
                        ? "text-green"
                        : item.apiCall === "delivering"
                        ? "text-red"
                        : ""
                    }
                    name={item.icon}
                  />
                  <span className="icon-text">&nbsp;{item.name}</span>
                </a>
              </li>
            ))}
            <li className="box-tools pull-right">
              <Button
                bsStyle="link"
                className="btn-box-tool text-large"
                onClick={this.onNewWorkClick.bind(this)}
              >
                <FontAwesome name="plus" />
                <span className="icon-text">
                  &nbsp;{messages["Add Worksheet"]}
                </span>
              </Button>
            </li>
          </ul>
          <div className="tab-content">
            {menu.map((item, index) => (
              <div
                key={index}
                className={"tab-pane " + (index == activeMenu ? "active" : "")}
              >
                {this.renderWorkTable(item, index)}
              </div>
            ))}
          </div>
        </div>
        <IframeModal ref="iframe" title={messages["Print Document"]} />
        <ConfirmPopup
          show={showUpgrade}
          title={messages["Notice"]}
          confirmTitle={messages["Upgrade New Version"]}
          cancelTitle={messages["Cancel"]}
          message={messages["Garage System"]}
          onConfirm={this.onUpgradeConfirm.bind(this)}
          onHide={() => {
            this.setState({ showUpgrade: false });
          }}
        />
        <TermOfServiceModal
          ref="tos"
          onAcceptClick={this.onAcceptClick.bind(this)}
        />
        {this.renderModalConfig()}
        <NotificationSystem ref="notificationSystem" />
      </div>
    );
  }
}

ReportWork.defaultProps = {
  showParkingTab: false,
  showPrintEmptyDoc: false,
  showVipMember: false,
};

export default connect(
  (state) => ({ messages: state.message.view.report.ReportWork }),
  null,
  null,
  { withRef: true }
)(ReportWork);



// WEBPACK FOOTER //
// ./src/view/report/ReportWork.js